import TWEEN from '@tweenjs/tween.js';

export function getAniProps(excludeActives) {
    let aniProps = {};
    aniProps.cubeIndex = 0;
    aniProps.cubeIndexs = [];
    aniProps.cubeIds = [];

    aniProps.x = 0;
    aniProps.y = 0;
    aniProps.z = 0;
    aniProps.delay = 0;
    aniProps.duration = 1000;
    aniProps.ease = TWEEN.Easing.Circular.Out;
    aniProps.instanced = !true;
    aniProps.stopPrevious = true;

    if(!excludeActives){
        aniProps.xActive = true;
        aniProps.yActive = true;
        aniProps.zActive = true;
        aniProps.rxActive = true;
        aniProps.ryActive = true;
        aniProps.rzActive = true;
        aniProps.sxActive = true;
        aniProps.syActive = true;
        aniProps.szActive = true;
    }

    aniProps.separateZ = false;
    aniProps.delayZ = 250;
    aniProps.easeZ = TWEEN.Easing.Cubic.InOut;
    aniProps.stopPreviousZ = true;
    return aniProps;
}